
import XTable from 'vux/src/components/x-table/index.vue'

export default {
name: "SalterHarrisClassification",
components: {
XTable,
},
};



// WEBPACK FOOTER //
// ./src/pages/formulas/Common/SalterHarrisClassification.vue